import type { LoaderFunctionArgs } from '@remix-run/node'
import style from './style.css?url'

import { fragmentLinks } from '~/fragments'

import { rudderStack } from '~/utils/rudder-stack.server'
import { H2, P, Stack } from '~/components-v2'
import { CallToAction } from '~/utils/a-b'

import compareToolsStyles from '~/styles/pages/compare-tools.css?url'
import quoteStyles from '~/components/quote-section/quote-section.css?url'
import blobStyles from '~/components-v2/blobby/blobby.css?url'
import compareCardStyles from '~/components-v2/compete-comparison-card/comparison-card.css?url'

import { BlobbyAww } from '~/components-v2/blobby/blobby'
import { G2ReviewCard } from '../_content.customer-support/g2-review-card'
import { g2Reviews } from '../_content.customer-support/g2-reviews'
import ThunderSalmonHeart from '../_content.customer-support/thunder-salmon-heart.svg?react'
import { compareItems } from './compare-items'
import {
  CustomersMarquee,
  customersMarqueeLinks,
} from '~/components/shared/customers-marquee'
import { BarChartIllustration } from './bar-chart-illustration'

const title = 'How does Omni compare?'
// const subTitle =
//   'Use a spreadsheet interface with a shared data model, unlocking scalable self-service analytics with consistent metrics.'
const keywords = 'How does Omni compare to other tools'
const description = keywords

export { meta } from '~/utils'
export const loader = async ({ request }: LoaderFunctionArgs) => {
  rudderStack(request, title)
  return { keywords, title, description }
}

export const links = () => [
  { rel: 'stylesheet', href: compareToolsStyles },
  { rel: 'stylesheet', href: quoteStyles },
  { rel: 'stylesheet', href: blobStyles },
  { rel: 'stylesheet', href: compareCardStyles },
  { rel: 'stylesheet', href: style },
  ...fragmentLinks.securityBadge(),
  ...customersMarqueeLinks(),
]

export default function () {
  return (
    <>
      <section className="compare-intro">
        <div className="gradients">
          <div className="vibes"></div>
          <div className="dawn"></div>
        </div>

        <Stack as="hgroup" className="centered-section-title" gap={4}>
          <h1>
            How does <mark>Omni</mark> compare?
          </h1>
        </Stack>

        <div className="compare-grid">
          {compareItems.map((item, index) => {
            return (
              <div className="compare-card" key={index}>
                <a href={item.link}>
                  <Stack row align="center" justify="center" gap={4} grow={1}>
                    <P fontSize="xxl" fontWeight={600} color="text3">
                      vs.
                    </P>
                    {item.logo}
                  </Stack>
                </a>
              </div>
            )
          })}
        </div>
      </section>

      <Stack as="hgroup" gap={5} className="centered-section-title">
        <h2 className="logo-header">
          Trusted by top data teams around the world
        </h2>
        <CustomersMarquee />
      </Stack>

      <section className="customer-love-wall full-width">
        <div className="thunder-salmon-hearts">
          <ThunderSalmonHeart />
          <ThunderSalmonHeart />
          <ThunderSalmonHeart />
        </div>

        <div className="awww">
          <BlobbyAww />
        </div>

        <div className="excited-blob"></div>
        <hgroup className="centered-section-title">
          <h3>Customer love</h3>
        </hgroup>

        <section className="grid cols3">
          {g2Reviews.map((review) => {
            return (
              <G2ReviewCard
                hideAvatar={true}
                review={review}
                key={review.name}
              />
            )
          })}
        </section>
      </section>

      <Stack
        as="hgroup"
        className="centered-section-title"
        gap={8}
        align="center"
      >
        <H2 fontSize="xxxl" fontWeight={600}>
          See how <mark>Omni</mark> stacks up
        </H2>
        <CallToAction className="button-call-to-action" />

        <BarChartIllustration />
      </Stack>
    </>
  )
}
